import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";

import {
  _CollectionType,
  Contract2,
  CurrencyType,
  PriceType,
} from "apollo/graphql.generated";
import { useCreateCollectionFormContext } from "~/features/collections/forms/CreateCollectionMultistepForm/context";
import useCurrencyDisplay from "~/features/collections/forms/CreateCollectionMultistepForm/useCurrencyDisplay";

const SPONSORED_MINT_LAUNCH_DATE = new Date(1718766648000); // June 19, 2024
const SPONSORED_MINT_UNSUPPORTED_CHAIN_IDS = [
  "1",
  "984122",
  "5000",
  "534352",
  "360",
];
const isSponsoredMintIncompatibleMEDeploy = (contract?: Contract2): boolean => {
  return (
    !contract ||
    !contract.createdAt ||
    new Date(contract.createdAt) < SPONSORED_MINT_LAUNCH_DATE
  );
};

const useSponsoredMints = (contracts: Contract2[] = []) => {
  const form = useCreateCollectionFormContext();
  const { paymentCurrency } = useCurrencyDisplay();
  const formValues = form.values;

  const priceType = formValues.distribution.priceType;
  const isPriceFixed = priceType === PriceType.Fixed;
  const isPublicSale = formValues.distribution.isDirectMint;
  const isWithoutMintVector = formValues.withoutMintVector;
  const isERC20 = paymentCurrency?.type === CurrencyType.ERC20;
  const collectorsChoiceSelected =
    !formValues.metadata.reveal &&
    formValues.collectionType == _CollectionType.Series;
  const incompatibleMultipleEditionsContractSelected =
    formValues.contract.type == "existing" &&
    isSponsoredMintIncompatibleMEDeploy(
      contracts.find((contract) => {
        return (
          contract.id ==
          (formValues.contract.data as { contractId: string }).contractId
        );
      })
    );

  const enableSponsoredMints = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_SPONSORED_MINTS
  );

  const disabledSponsoredMints =
    !enableSponsoredMints ||
    !isPriceFixed ||
    !isPublicSale ||
    isWithoutMintVector ||
    isERC20 ||
    collectorsChoiceSelected ||
    incompatibleMultipleEditionsContractSelected ||
    SPONSORED_MINT_UNSUPPORTED_CHAIN_IDS.includes(
      formValues.collection.chainId
    );

  return {
    disabledSponsoredMints,
  };
};

export default useSponsoredMints;
